import { selectors } from './';
import { connect } from 'react-redux';
import React from 'react';
import Error from '../../modules/shared/error';

const Main = props => <Error isNotFoundPage={true} {...props} />;

export default connect(
	state => ({
		intl: selectors.getIntl(state)
	})
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/not-found/main.js